'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function Template({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname.startsWith('/docs')) {
      document.documentElement.classList.add('docs');
    } else {
      document.documentElement.classList.remove('docs');
    }
  }, [pathname]);

  return children;
}
